<template>
  <v-tooltip top>
    <v-btn fab dark small color="amber darken-2" slot="activator" @click="download()">
      <v-icon>description</v-icon>
    </v-btn>
    <span>{{title}}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    title: String
  },
  methods: {
    download() {
      this.$emit("download");
    }
  }
};
</script>

<style>
</style>
